import React from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const StockVariationsGraph = ({ data }) => {
  if (data) {
    // @ts-ignore
    return (
      <Bar
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: false,
              position: "bottom" as const,
            },
          },
          scales: {
            y: {
              type: "linear" as const,
              display: true,
              position: "left" as const,
              grid: {
                drawOnChartArea: false,
              },
              ticks: {
                callback: function (value) {
                  // Only show integer values
                  return Number.isInteger(value) ? value + " pcs" : null;
                },
              },
            },
          },
        }}
        data={{
          labels: data?.map((scan) => {
            // format  scan.createdAt date to be displayed dd/mm/yyyy hh:mm
            let date = new Date(scan.createdAt);

            // Tableau des jours de la semaine
            const joursSemaine = [
              "dim",
              "lun",
              "mar",
              "mer",
              "jeu",
              "ven",
              "sam",
            ];

            // Récupérer les différentes parties de la date
            let jourSemaine = joursSemaine[date.getDay()]; // jour de la semaine
            let jour = date.getDate().toString().padStart(2, "0"); // jour du mois
            let mois = (date.getMonth() + 1).toString().padStart(2, "0"); // mois, +1 car les mois commencent à 0
            let annee = date.getFullYear(); // année
            let heures = date.getHours().toString().padStart(2, "0"); // heures, avec ajout d'un 0 si nécessaire

            return `${jourSemaine} ${jour}/${mois}`;
          }),
          datasets: [
            {
              label: data?.map((scan) =>
                scan.salesSum > 0 ? "Réassorts" : "Ventes"
              ),
              data: data?.map((scan) => scan.salesSum),
              backgroundColor: data?.map((scan) =>
                scan.salesSum > 0
                  ? "rgba(159, 235, 53, 0.5)"
                  : "rgba(53, 162, 235, 0.5)"
              ),
            },
          ],
        }}
      />
    );
  }

  return null;
};

//  options={{
//           responsive: true,
//           interaction: {
//             mode: "index" as const,
//             intersect: false,
//           },
//           scales: {
//             y: {
//               type: "linear" as const,
//               display: true,
//               position: "left" as const,
//               grid: {
//                 drawOnChartArea: false,
//               },
//               ticks: {
//                 // Utilisez la fonction callback pour forcer les entiers
//                 callback: function (value) {
//                   if (Number.isInteger(value)) {
//                     return value + " €";
//                   }
//                 },
//               },
//             },
//           },
//         }}
